export default __webpack_public_path__ + "static/media/dental.928305bb.png";